import Constants from '../utils/consts';
import SqlString from 'sqlstring';
var http = require('follow-redirects').http;
var qs = require('querystring');

export default async function AddMeeting(username, token, eventId, companyId, companyBroker, investorIds, investorBrokersIds, date, hour, minutes, slots, notes, notesRaw) {
    return new Promise(function (resolve, reject) {
        var options = {
        'method': 'POST',
        'hostname': Constants.ipAddress,
        'path': '/apis/addMeeting.php',
        'headers': {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cookie': 'uid=e02675a1a7516909792f6850dffcd5fe'
        },
        'maxRedirects': 20
        };

        var req = http.request(options, function (res) {
        var chunks = [];

        res.on("data", function (chunk) {
            chunks.push(chunk);
        });

        res.on("end", function (chunk) {
            var body = Buffer.concat(chunks);
            console.log(body.toString());
            const sad = body.toString();
            const resp = JSON.parse(body.toString());
            resolve(resp);
        });

        res.on("error", function (error) {
            console.error(error);
        });
        });

        var postData = qs.stringify({
            'uname': username,
            'token': token,
            'eventId': eventId,
            'companyId': companyId,
            'investorIds': JSON.stringify({value: investorIds}),
            'date': date,
            'hour': hour,
            'minutes': minutes,
            'slots': slots,
            'notes': notes,
            'notesRaw': notesRaw,
            'companyBroker': companyBroker,
            'investorBrokersIds': JSON.stringify({value: investorBrokersIds}),
        });

        console.log(postData);
        req.write(postData);

        req.end();

        
    });
}
